import SuperFetch from '../../superFetch.js';

class TagApi {
  /**
   *  [태그 등록] 태그 등록하기 전 필요한 데이터 가져오기
   */
  prepareInsertTag = (data) => SuperFetch.post('/tag/insert/preparation', data);

  /**
   *  [태그 등록] 태그명 중복검사 요청하기
   */
  checkTagName = (data) => SuperFetch.post('/tag/insert/preparation/tag/check', data);

  /**
   *  [태그 등록] 태그 등록하기 전 필요한 데이터 가져오기
   */
  getTagSearchList = (data) => SuperFetch.post('/tag/insert/preparation/tag/search', data);

  /**
   *  [태그 등록] 태그 상세 미리보기 데이터 요청히기
   */
  getTagDetailPreviewData = (data) => SuperFetch.post('/tag/insert/preparation/preview', data);

  /**
   *  [태그 등록] 태그 등록 요청하기
   */
  insertTag = (data) => SuperFetch.post('/tag/insert', data);

  /**
   *  [태그 리스트] 태그 리스트 요청하기
   */
  getTagList = (data) => SuperFetch.post('/tag/list', data);

  /**
   *  [태그 상세 내역] 태그 상세 내역 요청하기
   */
  getTagHistory = (data) => SuperFetch.post('/tag/history', data);

  /**
   *  [태그 상세 내역] 상품 리스트 가져오기
   */
  getTagHistoryRelatedProductList = (data) => SuperFetch.post('/tag/history/related/product/list', data);

  /**
   *  [태그 상세 내역] 브랜드 리스트 가져오기
   */
  getTagHistoryRelatedStoreList = (data) => SuperFetch.post('/tag/history/related/store/list', data);

  /**
   *  [태그 상세 내역] 기획전 리스트 가져오기
   */
  getTagHistoryRelatedEventList = (data) => SuperFetch.post('/tag/history/related/event/list', data);

  /**
   *  [태그 상세 내역] 상품 후기 리스트 가져오기
   */
  getTagHistoryRelatedReviewList = (data) => SuperFetch.post('/tag/history/related/review/list', data);

  /**
   *  [태그 그룹 등록] 태그 그룹명 중복검사 요청하기
   */
  checkTagGroupName = (data) => SuperFetch.post('/tag/group/insert/preparation/check', data);

  /**
   *  [태그 그룹 등록] 태그 그룹 아이템 리스트 가져오기
   */
  getTagGroupItemList = (data) => SuperFetch.post('/tag/group/insert/preparation/tag/list', data);

  /**
   *  [태그 그룹 등록] 태그 그룹 등록 요청하기
   */
  insertTagGroup = (data) => SuperFetch.post('/tag/group/insert', data);

  /**
   *  [태그 그룹 리스트] 태그 그룹 리스트 요청하기
   */
  getTagGroupList = (data) => SuperFetch.post('/tag/group/list', data);

  /**
   *  [태그 그룹 상세] 태그 그룹 상세 요청하기
   */
  getTagGroupDetail = (data) => SuperFetch.post('/tag/group/detail', data);

  /**
   *  [태그 그룹 편집] 태그 그룹 편집 요청하기
   */
  editTagGroup = (data) => SuperFetch.post('/tag/group/edit', data);

  /**
   *  [태그 상세] 태그 상세 요청하기
   */
  getTagDetail = (data) => SuperFetch.post('/tag/detail', data);

  /**
   *  [태그 편집] 태그 편집 요청하기
   */
  editTag = (data) => SuperFetch.post('/tag/edit', data);

  /**
   *  [태그 편집] 태그 등록 거절 요청하기
   */
  rejectRegistrationTag = (data) => SuperFetch.post('/tag/edit/reject', data);

  /**
   *  [태그 탭 메인] 태그 탭 메인 데이터 요청하기
   */
  getTagTabMainData = (data) => SuperFetch.post('/tag/management/tab/main', data);

  /**
   *  [태그 탭 메인] 태그 탭 메인에 연결할 컨텐츠 리스트 요청하기
   */
  getTagTabMainContentsList = (data) => SuperFetch.post('/tag/management/tab/main/preparation/tag/list', data);

  /**
   * [태그 탭 메인] 태그 탭 메인 미리보기 데이터 요청히기
   */
  getTagTabMainPreviewData = (data) => SuperFetch.post('/tag/management/tab/main/preview', data);

  /**
   *  [태그 탭 메인] 태그 탭 메인 편집 요청하기
   */
  editTagTabMain = (data) => SuperFetch.post('/tag/management/tab/main/edit', data);

  /**
   *  [태그 트렌드 키워드] 태그 트렌드 키워드 데이터 요청하기
   */
  getTagTrendKeywordData = (data) => SuperFetch.post('/tag/management/trend/keyword', data);

  /**
   *  [태그 트렌드 키워드] 태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기
   */
  getTagTrendKeywordContentsList = (data) =>
    SuperFetch.post('/tag/management/trend/keyword/preparation/tag/list', data);

  /**
   * [태그 트렌드 키워드] 태그 트렌드 키워드 미리보기 데이터 요청히기
   */
  getTagTrendKeywordPreviewData = (data) => SuperFetch.post('/tag/management/trend/keyword/preview', data);

  /**
   *  [태그 트렌드 키워드] 태그 트렌드 키워드 편집 요청하기
   */
  editTagTrendKeyword = (data) => SuperFetch.post('/tag/management/trend/keyword/edit', data);

  /**
   *  [태그 그룹 등록/편집] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  getTagGroupAllListExcelDownload = (data) =>
    SuperFetch.post('/tag/group/insert/preparation/tag/list/excel/download', data);

  /**
   *  [태그 메인 탭 관리] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  getTagTabMainAllListExcelDownload = (data) =>
    SuperFetch.post('/tag/management/tab/main/preparation/tag/list/excel/download', data);

  /**
   *  [태그 트렌드 키워드 관리] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  getTagTrendKeywordAllListExcelDownload = (data) =>
    SuperFetch.post('/tag/management/trend/keyword/preparation/tag/list/excel/download', data);

  /**
   *  [태그 그룹 등록/편집] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  getTagGroupSelectedListExcelDownload = (data) =>
    SuperFetch.post('/tag/group/insert/preparation/tag/list/excel/download/selected', data);

  /**
   *  [태그 메인 탭 관리] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  getTagTabMainSelectedListExcelDownload = (data) =>
    SuperFetch.post('/tag/management/tab/main/preparation/tag/list/excel/download/selected', data);

  /**
   *  [태그 트렌드 키워드 관리] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  getTagTrendKeywordSelectedListExcelDownload = (data) =>
    SuperFetch.post('/tag/management/trend/keyword/preparation/tag/list/excel/download/selected', data);

  /**
   *  [태그 그룹 등록/편집] 태그 엑셀 업로드
   */
  setTagGroupExcelUpload = (data) => SuperFetch.post('/tag/group/insert/preparation/tag/list/excel/upload', data);

  /**
   *  [태그 메인 탭 관리] 태그 엑셀 업로드
   */
  setTagTabMainExcelUpload = (data) =>
    SuperFetch.post('/tag/management/tab/main/preparation/tag/list/excel/upload', data);

  /**
   *  [태그 트렌드 키워드 관리] 태그 엑셀 업로드
   */
  setTagTrendKeywordExcelUpload = (data) =>
    SuperFetch.post('/tag/management/trend/keyword/preparation/tag/list/excel/upload', data);

  /**
   *  [태그 리스트] 엑셀 다운로드
   */
  getTagListExcelDownload = (data) => SuperFetch.post('/tag/list/excel/download', data);
}

export default new TagApi();
